import React from 'react';
import CountryResults from '../../partials/quota-analysis-results/quota-analysis-results.component';
import TaxonomyFilters from '../../partials/taxonomy-filters/taxonomy-filters.component';
import GlobalStatistics from '../../partials/global-statistics/global-statistics.component';
import PageHeader from '../../layout/page-header/page-header.component';
import Page from '../../layout/page/page.component';
import { useAppState } from '../../../hooks/use-app-state.hook';
import { useCountryProfileFilters } from '../../../hooks/use-country-profile-filters.hook';
import Button from '../../layout/button/button.component';
import { tabButtonClassName, tabButtonpadClassName } from './quota-analysis-page.style';
import { useSearchParams } from 'react-router-dom';

const QuotaAnalysisPage: React.FC = () => {
    const [params] = useSearchParams();
    const localLevelActivated = params.get('profileType') === 'localGovernment';
    const [filters, changeFilters] = useCountryProfileFilters({
        localLevel: localLevelActivated
    });
    const [, {
        getTaxonomies,
        getCountryProfileResultList,
        getPage
    }] = useAppState();
    const filtersWithCustomLocalLevel = {
        ...filters,
        localLevel: localLevelActivated,
    };
    const countryProfileResults = ((results, filters) => (
        (
            filters.typeOfQuotaIds.length > 0
            || filters.electoralSystemIds.length > 0
            || filters.legalSourcesIds.length > 0
        )
            ? results.filter(result => Boolean(result.countryProfile))
            : results
    ))(
        getCountryProfileResultList(filtersWithCustomLocalLevel),
        filters
    );
    const taxonomies = getTaxonomies(filtersWithCustomLocalLevel);
    const page = getPage('Quota Analysis');

    return (
        <Page theme={ localLevelActivated ? 'green' : 'blue' }>
            <PageHeader title={ page?.name } description={ page?.html }>
                <div className={ tabButtonpadClassName }>
                    <Button
                        className={ tabButtonClassName }
                        format={ localLevelActivated ? 'white' : 'default' }
                        link='?profileType=parliament'>
                        Parliament
                    </Button>
                    <Button
                        className={ tabButtonClassName }
                        format={ localLevelActivated ? 'default' : 'white' }
                        link='?profileType=localGovernment'>
                        Local government
                    </Button>
                </div>
            </PageHeader>
            <GlobalStatistics localLevel={ localLevelActivated }/>
            <hr/>
            <TaxonomyFilters
                taxonomies={ taxonomies }
                filters={ filtersWithCustomLocalLevel }
                onChangeFilters={ changeFilters }/>
            <CountryResults
                results={ countryProfileResults }
                filters={ filtersWithCustomLocalLevel }
                onChangeFilters={ changeFilters }/>
        </Page>
    );
}

export default QuotaAnalysisPage;
